module.exports = __webpack_public_path__ + "static/media/preparacion.dd66c942.svg";